import styled from "styled-components";

export const AdsSlotWrapper = styled.div<{ style?: any }>`
  ${({ style }) => style}
`;
